import {Component, inject} from '@angular/core'
import {OldPropertyStatusMap, propertiesExcludedFromKalp} from '@sparbanken-syd/loan-backend'
import {PropertyTypePipe} from '../../../pipes/property-type.pipe'
import {LoanService} from '../../../services/loan.service'
import {KalpItemComponent} from '../kalp-item/kalp-item.component'

@Component({
  selector: 'spb-kalp-old-property',
  templateUrl: './old-property.component.html',
  styleUrls: ['../kalp.component.scss'],
  imports: [KalpItemComponent, PropertyTypePipe]
})
export class OldPropertyComponent {
  public readonly loanService = inject(LoanService)
  protected readonly OldPropertyStatusMap = OldPropertyStatusMap
  protected readonly propertiesWithoutKalp = propertiesExcludedFromKalp
}
